import React from "react";
import PolicyLayout from "./PolicyLayout";

const sections = [
  <>Welcome to <b>Alpaago</b>. By accessing or purchasing through our website, you agree to abide by our terms of service.</>,
  <>All prices are listed in INR and include applicable taxes. Product descriptions and availability are subject to change without notice.</>,
  <>We reserve the right to refuse or cancel orders in case of pricing errors or suspected fraudulent activity.</>,
  <>For any dispute, the jurisdiction will be Bengaluru, Karnataka, India.</>,
];

export default function TermsConditions() {
  return <PolicyLayout title="Terms & Conditions" sections={sections} />;
}
